import { render, staticRenderFns } from "./BB-comparing.vue?vue&type=template&id=456cd791&"
import script from "./BB-comparing.vue?vue&type=script&lang=js&"
export * from "./BB-comparing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports